import {
  ArrowRightOnRectangleIcon,
  Cog8ToothIcon,
  InformationCircleIcon,
  UserIcon,
  UserPlusIcon,
} from '@heroicons/react/24/outline/index.js';
import { INavConfigDesktop } from '@pendwa/common-browser/components/Navs/Nav/types.js';
import { IContextPageDataViewer } from '@pendwa/common-browser/context/PageData/index.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { filterOutNullOrUndefined } from '@pendwa/common/utils/isDefinedAndNotNull.js';
import { moreLinks } from '../links/more.js';

export const rightSection = (params: {
  viewer?: IContextPageDataViewer;
}): INavConfigDesktop['right_section'] => {
  return {
    label: params.viewer?.name ?? 'Account',
    children: filterOutNullOrUndefined([
      !params.viewer
        ? {
            label: 'Sign Up',
            navigate: {
              description: 'Create your account today.',
              href: rootRoutes.app.account.create.get(window.location.href),
            },
            icon: UserPlusIcon,
          }
        : undefined,
      !params.viewer
        ? {
            label: 'Sign In',
            navigate: {
              description: 'Log in to your account.',
              href: rootRoutes.app.account.login.get(window.location.href),
            },
            icon: UserIcon,
          }
        : undefined,
      params.viewer
        ? {
            label: 'Settings',
            navigate: {
              description: 'Account settings.',
              href: rootRoutes.settings.main.get(),
            },
            icon: Cog8ToothIcon,
          }
        : undefined,
      {
        label: 'Help and Support',
        navigate: {
          description: `Get help with ${browserRootConfig.project.name}.`,
          href: browserRootConfig.project.help_url,
        },
        icon: InformationCircleIcon,
      },
      params.viewer
        ? {
            label: 'Logout',
            navigate: {
              description: 'Sign out of your account.',
              href: rootRoutes.app.logout.main.get(),
            },
            icon: ArrowRightOnRectangleIcon,
          }
        : undefined,
      {
        label: 'More',
        links: moreLinks(params),
      },
    ]),
  };
};
